import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Carta = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchCartas()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const ver = async (id) => {
        props.ver(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.carta.secretaria}: {props.carta.servico}</Card.Title>
                    </Card.Body>
                    <Button type='button' className="botao-leis" onClick={() => ver(props.carta._id)} variant='success'>Visualizar</Button>
                    <Button type="button" className="botao-leis" onClick={() => editar(props.carta._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.carta._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Carta;